import { ClientDocumentRelation } from 'ngx-mat-esign360/lib/transaction/model/client-document-relation.model';
import {
  IDocumentCheckbox,
  IDocumentSignField,
} from 'ngx-mat-esign360/lib/transaction/model/document-field.model';
import { IDocumentSigner } from 'ngx-mat-esign360/lib/transaction/model/document-signer.model';
import { SigningState } from './signing-state.model';

export interface IDocument {
  id: string;
  name: string;
  fileId: string;
  relationType: ClientDocumentRelation;
  metadataId: string;
  disabled: boolean;
  processed: boolean;
  locked: boolean;
  isBeingModified: boolean;
  isFinalized: boolean;
  signers: IDocumentSigner[];
}

export class TxDocument implements IDocument {
  constructor(
    public id: string,
    public name: string,
    public fileId: string,
    public relationType: ClientDocumentRelation,
    public metadataId: string,
    public disabled: boolean,
    public processed: boolean,
    public locked: boolean,
    public isBeingModified: boolean,
    public isFinalized: boolean,
    public signers: IDocumentSigner[] = []
  ) {}

  isSignDocument(): boolean {
    return this.relationType === ClientDocumentRelation.MustSign;
  }

  isOptionalReadDocument(): boolean {
    return this.relationType === ClientDocumentRelation.CanRead;
  }

  hasSignerById(clientId: string): boolean {
    return !!this.getSignerById(clientId);
  }

  getSignerById(clientId: string) {
    return this.signers.find(
      (signer) =>
        signer.clientId === clientId && signer.relation !== ClientDocumentRelation.CannotRead
    );
  }

  hasBeenProcessedBySigner(clientId: string) {
    return this.getSignerById(clientId).signingState === SigningState.Finished;
  }

  getAllSignFields(): IDocumentSignField[] {
    return this.signers.reduce((signFields, signer) => {
      return signFields.concat(signer.signFields);
    }, []);
  }

  getAllCheckboxes(): IDocumentCheckbox[] {
    return this.signers.reduce((checkboxes, signer) => {
      return checkboxes.concat(signer.checkboxes);
    }, []);
  }

  getSignFieldById(id: string): IDocumentSignField {
    return this.getAllSignFields().find((signField) => signField.id === id);
  }

  getSignFieldByPdfId(pdfId: string): IDocumentSignField {
    return this.getAllSignFields().find((signField) => signField.pdfId === pdfId);
  }

  getCheckboxByPdfId(pdfId: string): IDocumentCheckbox {
    return this.getAllCheckboxes().find((checkbox) => checkbox.pdfId === pdfId);
  }
}
